import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { CropField, GetCropFieldsResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropFieldService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = `${this.env.APIM_BASE_URL}/arable-advice-service/crop-fields`;
  private cropFieldType = 'ManureSpace';

  getCropFields(cropYear: number): Observable<CropField[]> {
    return this.http
      .get<GetCropFieldsResponse>(`${this.baseUrl}/year/${cropYear}/type/${this.cropFieldType}`)
      .pipe(map((d) => d.cropFields.map((cropField) => ({ ...cropField }))));
  }
}
